import { useMemo } from 'react';
import moment from 'moment';
import { useGetProjectsQuery } from '@/slices/projectSlice';

const RECENT_DAYS = 90;

// Shares the cached project list that useJobs already loads, so this adds no request
const useHasRecentQuoteOrInvoice = (): boolean => {
	const { data } = useGetProjectsQuery(undefined);

	return useMemo(() => {
		const since = moment().subtract(RECENT_DAYS, 'days');

		return Object.values(data?.entities || {}).some((project: any) =>
			[project?.quote, project?.runnerInvoice].some(
				(workflow) =>
					workflow?.createdAt &&
					moment(workflow.createdAt).isAfter(since)
			)
		);
	}, [data]);
};

export default useHasRecentQuoteOrInvoice;
